import React, { useState } from "react";
import EventRow from "../EventRow/EventRow";
import { BellRingOutlined } from "@toddle-edu/ds-icons";
import {
  setValue,
  mapStateToProps,
  mapActionCreators,
} from "../../modules/Utils";
import { connect } from "react-redux";
import { Checkbox } from "@toddle-edu/ds-web";
import { useI18n } from "Hooks";
import classes from "./Notification.scss";

const Notification = props => {
  const {
    eventModalV2,
    updateEventModalV2,
    notifyLabelLocales = "calendar:notify_participants_on_creation_of_the_event",
    testId = "",
  } = props;
  const [shouldNotifyParticipants, setShouldNotifyParticipants] = useState(
    eventModalV2?.shouldNotifyParticipants
  );
  const { t } = useI18n(["calendar"]);
  const toggleNotifyParticipants = setValue(
    "shouldNotifyParticipants",
    updateEventModalV2
  );
  const onChangeHandler = () => {
    setShouldNotifyParticipants(!shouldNotifyParticipants);
    toggleNotifyParticipants(!shouldNotifyParticipants);
  };

  return (
    <EventRow
      className={classes.container}
      labelClass={classes.label}
      label="common:notification"
      icon={<BellRingOutlined variant="subtle" />}
      renderComponent={() => (
        <div className={classes.notifyContainer}>
          <Checkbox
            isChecked={shouldNotifyParticipants}
            dsVersion="2.0"
            size="medium"
            onClick={onChangeHandler}
            testId={`${testId}-notify-participants`}
          />
          <div className="text-body">{t(notifyLabelLocales)}</div>
        </div>
      )}
    />
  );
};

export default connect(mapStateToProps, mapActionCreators)(Notification);
